module.exports = __webpack_public_path__ + "img/ecash_moeda.5d1af4df.png";